module.exports = __webpack_public_path__ + "img/weddings_20_V.efc7eda5.webp";